import { createContext, useMemo } from "react";
import { Outlet } from "react-router";
import ConfigurationsContextFallback from "components/common/ErrorBoundaries/ErrorBoundaryFallbacks/ConfigurationsContextFallback";
import { Loading } from "components/shared";
import useGraphQLQuery from "hooks/api/GQL";
import queryConfig from "hooks/api/GQL/queryConfig";
import { TConfigurationsContextValue } from "./types";
import { getFeatureFlags } from "./utils";

export const ConfigurationsContext = createContext<
  TConfigurationsContextValue | undefined
>(undefined);

export const ConfigurationsProvider = () => {
  const {
    data: configurations,
    isSuccess: isConfigurationsRequestSucceeded,
    isError: isConfigurationsRequestFailed,
  } = useGraphQLQuery(queryConfig.getConfigurations);

  const value = useMemo(
    () => ({
      featureFlags: getFeatureFlags(configurations ?? []),
      tenants: (configurations ?? []).map(({ tenantId }) => tenantId),
      configurations: configurations ?? [],
    }),
    [configurations],
  );

  return (
    <ConfigurationsContext.Provider value={value}>
      {isConfigurationsRequestSucceeded ? (
        <Outlet />
      ) : isConfigurationsRequestFailed ? (
        <ConfigurationsContextFallback />
      ) : (
        <Loading />
      )}
    </ConfigurationsContext.Provider>
  );
};
